import React from "react";
import { Quote } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";

// Placeholder testimonials
const PLACEHOLDERS = [
  {
    name: "Coming Soon",
    role: "Brand Partner",
    quote: "Client testimonials from tourism boards, brands and creators will appear here as collaborations complete.",
  },
  {
    name: "Reserved",
    role: "Tourism Board",
    quote: "This carousel is ready to showcase words from partners after each campaign wraps.",
  },
  {
    name: "Available",
    role: "Lifestyle Brand",
    quote: "Have you worked with Tariq? Reach out — your story could sit right here.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-36 px-6 md:px-10"
      data-testid="testimonials-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          number="07"
          tag="Testimonials"
          title={<>
            Words from <span className="text-gradient-gold">Collaborators</span>
          </>}
          kicker="A space reserved for brands, tourism boards and creators to share their experience — filling up as new work ships."
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {PLACEHOLDERS.map((t, i) => (
            <Reveal key={i} delay={i * 100}>
              <div className="glass rounded-2xl p-8 h-full relative overflow-hidden raise-hover">
                <Quote className="absolute top-4 right-4 w-16 h-16 text-[#D4AF37]/8" />
                <p className="font-serif-display italic text-lg text-white/80 leading-relaxed mb-8 min-h-[7rem]">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 pt-6 border-t border-white/5">
                  <div className="w-11 h-11 rounded-full border border-[#D4AF37]/40 bg-[#0A0A0A] flex items-center justify-center font-display text-[#D4AF37] text-sm">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-display text-sm text-white">{t.name}</p>
                    <p className="text-[10px] uppercase tracking-[0.25em] text-[#B3B3B3]">{t.role}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
